/* @jsx h */
import { defineComponent, h } from "vue";
import { cn } from "../utils";

export interface RichTextContentProps {
  /**
   * Rich-text HTML to render. This is expected to already be sanitized server-side
   * at write time (the trust boundary), so rendering it here is safe by construction.
   */
  html?: string | null;
  className?: string;
}

/**
 * Renders rich-text HTML produced by RichTextEditor.
 *
 * Intentionally dependency-free (no Tiptap, no sanitizer) so it stays light enough
 * to ship in the public customer bundle. The editor lives behind a separate
 * `@lemmonhq/uikit/rich-text-editor` entry so Tiptap/ProseMirror never reaches here.
 */
export const RichTextContent = defineComponent<RichTextContentProps>({
  name: "RichTextContent",
  props: ["html", "className"],
  setup(props) {
    return () =>
      props.html
        ? h("div", {
            class: cn("prose max-w-none", props.className),
            innerHTML: props.html,
          })
        : null;
  },
});
